import { WeekdaysArray } from '../../core/constants/base-calendar-values';
import { BaseWeekDays } from '../../modules/inquiry/_enums/base-inquiry.enum';

export const mapDaysOfWeekToNumbers = (weekdays: Record<BaseWeekDays, boolean>) => {
  return WeekdaysArray.flatMap((weekDay, index) => (weekdays[weekDay] ? [index] : []));
};
